import React from 'react';
import { makeStyles,CircularProgress,Backdrop, FormControlLabel,Checkbox, Grid } from '@material-ui/core';
import AutoComplete from "../../../../SkapaMote/Inputs/AutoComplete";
import Orgnr from "../../../../SkapaMote/Inputs/Orgnr";

import BussinesIcon from "@material-ui/icons/Business";
import Divider from "@material-ui/core/Divider";
import { isEmpty,isUndefined } from 'lodash';
import KundAutoComplete from '../../../../KundAutoComplete'
import Spinner from "../../../../Spinner"
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

export default function InputComponent(props) {
    const classes = useStyles();
    const [isLoading,setisLoading]= React.useState(false)
    const onStartLoading=()=>{setisLoading(true)}
    const onEndLoading=()=>{setisLoading(false)}
    return (
        <Grid container spacing={2}>
          <Grid item xs={7}>
            {parseInt(props.isFrom)===0?
              <KundAutoComplete
              // Kund={nOrder.Kund}
              Value={isUndefined(props.Kund.KundNamn)?0:props.Kund.KundNamn}
              selectthisKund={props.selectthisKund}
                  /> 
              :
              <AutoComplete
              KundNamn={props.Kund.KundNamn}
              Kund={props.Kund}
              isFrom={props.isFrom}
              selectthisKund={props.selectthisKund}
              onStartLoading={onStartLoading}
              onEndLoading={onEndLoading}
              />
            }
          </Grid>
          
          <Grid item xs={5}>
            <Orgnr
              Orgnr={
                  isUndefined(props.Kund.Orgnr_Af)?"":
                  isEmpty(props.Kund.Orgnr_Af)?
                  String(props.Kund.Orgnr).split("_")[0]
                  :
                  props.Kund.Orgnr_Af
              }
            />
          </Grid>
          {/* {
              isLoading===true?
              <Spinner/>
              :
              <>
          <div className="col-4"  style={{ height: 'auto' }}>
              
          </div> */}
          {/* </> */}
          {/* } */}
        </Grid>
          
    );
}